export default __webpack_public_path__ + "media/images/sort_asc_disabled-d7dc10c78f23615d328581aebcd805eb.png";